import { Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-supplement-items',
  imports: [NgForOf],
  templateUrl: './aya-supplement-items.component.html',
  styleUrls: ['./aya-supplement-items.component.scss', './print-aya-supplement-items.component.scss'],
})
export class AyaSupplementItemsComponent {
  @Input() title = '';
  @Input() items = [];
}
